module.exports = __webpack_public_path__ + "static/media/filterIcon.2cc440ac.svg";